// extracted by mini-css-extract-plugin
export default {"loader":"CertificationLoader_loader__cdClv"};